import { Dispatch, Action } from 'redux'
import { StripeSubscriptionDropdownMapDispatchReturnType } from './types/StripeSubscriptionDropdownMapDispatchReturnType'

export const StripeSubscriptionDropdownMapDispatch = (
  _dispatch: Dispatch<Action>
): StripeSubscriptionDropdownMapDispatchReturnType => {
  return {}
}
